import { ModalLayout } from '@starsoft/common/components';
import { CommonModalsKey } from '@starsoft/common/enums';
import { useTranslation } from '@starsoft/common/hooks';
import ImageUploadContent from './Content';

import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';

export default function ImageUpload() {
  const { t } = useTranslation('common');
  const isAdminEmbed = useSelector(
    (state: RootState) => state.theme.isAdminEmbed,
  );

  if (!isAdminEmbed) {
    return null;
  }

  return (
    <ModalLayout modal={CommonModalsKey.UploadImage} title={t('upload_image')}>
      <ImageUploadContent />
    </ModalLayout>
  );
}
